<template>
  <div id="help-support">
    <vs-row>
      <vs-col vs-align="center" vs-w="6" v-if="!disablePedbotReferences">
        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-input 
              class="w-full" 
              icon-pack="feather" 
              icon="icon-user" 
              icon-no-border 
              label-placeholder="Nome" 
              v-model="formData.full_name"
              v-validate="'required'"
              name="nome"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('nome')"
            >
              {{ errors.first('nome') }}
            </span>
          </div>
        </div>

        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-input 
              class="w-full" 
              icon-pack="feather" 
              icon="icon-phone" 
              icon-no-border 
              label-placeholder="Telefone" 
              v-model="formData.phone_number"
              v-mask="phoneNumberMask"
              v-validate="'required|min:14'"
              name="telefone"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('telefone')"
            >
              {{ errors.first('telefone') }}
            </span>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-input 
              class="w-full" 
              icon-pack="feather"
              icon="icon-mail" 
              icon-no-border 
              label-placeholder="E-mail" 
              v-model="formData.email"
              v-validate="'required|email'"
              data-vv-as="email"
              name="e-mail"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('e-mail')"
            >
              {{ errors.first('e-mail') }}
            </span>
          </div>
        </div>

        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-textarea 
              class="text-area w-full" 
              placeholder="Escreva sua mensagem..." 
              v-model="formData.message" 
              height="230px"
              v-validate="'required'"
              name="mensagem"
            />
              <span
                class="text-danger text-sm"
                v-show="errors.has('mensagem')"
              >
                {{ errors.first('mensagem') }}
              </span>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button class="mr-3 mb-2" @click="submitForm" :disabled="!isFormValid">Enviar</vs-button>
          </div>
        </div>
      </vs-col>

      <vs-col vs-type="flex" vs-justify="flex-start" :vs-align="phoneAlign" style="flex-direction: column" vs-w="6">
        <div class="mb-5">
          <span class="text-muted">Fale conosco</span>
        </div>

        <vs-col vs-type="flex" :vs-justify="phoneAlign" :vs-align="phoneAlign" vs-w="12">
          <img
            :src="require('@/assets/images/brands/whatsapp.svg')"
            width="32"
            height="32"
            class="mr-3"
          />
          <a :href="waMeLink" target="_blank">
            <span class="h2 text-success">{{ supportPhoneNumber }}</span>
          </a>
        </vs-col>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
  import { encodeToBase64, parsePhoneNumber } from '@/utils'
  import supportEmail from '@/http/requests/supportEmail'

  export default {
    name: 'help-support',
    data() {
      return {
        isMounted: false,
        formData: {
          full_name: '',
          phone_number: '',
          email: '',
          message: ''
        }
      }
    },
    computed: {
      phoneAlign() {
        if (this.disablePedbotReferences) {
          return 'start'
        }

        return 'center'
      },
      disablePedbotReferences() {
        return process.env.VUE_APP_DISABLE_PEDBOT_REFERENCES === 'true'
      },
      waMeLink() {
        return 'https://wa.me/' + parsePhoneNumber(process.env.VUE_APP_SUPPORT_PHONE_NUMBER);
      },
      supportPhoneNumber() {
        return process.env.VUE_APP_SUPPORT_PHONE_NUMBER;
      },
      isFormValid() {
        return !this.errors.any()
      },
      phoneNumberMask() {
        if (this.formData.phone_number.startsWith('0800') || this.formData.phone_number.startsWith('(08) 00')) {
          return '#### ### ####'
        }
        else if (this.formData.phone_number.startsWith('800') || this.formData.phone_number.startsWith('(80) 0')) {
          return '### ### ####'
        }
        return ['(##) ####-####', '(##) #####-####']
      } 
    },
    methods: {
      submitForm() {
        const formData = this.$_.cloneDeep(this.formData);
        formData.message = encodeToBase64(formData.message);

        this.$validator.validateAll().then(result => {
          if (result) {
            supportEmail.sendSupportEmail(formData).then(() => {
              this.formData = {
                full_name: '',
                phone_number: '',
                email: '',
                message: ''
              }

              this.errors.clear()
              this.$validator.reset()

              this.$vs.notify({
                color: 'success',
                title: 'Muito obrigado!',
                text: 'Sua mensagem foi enviada com sucesso!'
              })
            })
            .catch((error) => { console.error(error) })
          }
        })
      }
    },
    mounted() {
      this.isMounted = true;
    }
  }
</script>

<style lang="scss">
.text-area {
  background: #fff;

  textarea {
    height: 230px;
  }
}
</style>